export const environment = {
  production: true,
  timerMinutos: 17,
  warningMinutos: 5,
  warningCountdownSegundos: 30,
  renovaMinutos: 10,
  extiendeCarritoMinutos: 60,
  PaypalAmbiente: 'https://www.paypal.com/sdk/js?client-id=ATsnhu44NueZp7SnVuwAertIxRbFokIEPm5gPhNlVsJSfFqiybGPtPo4PyGCfZW1hKEuj5GlrFs69DVk&currency=MXN&vault=true',
  UrlBase: 'https://serviciosapp.sorteoanahuac.mx/',
  UrlPagosUnificados: 'https://serviciospagos.sorteoanahuac.mx/',
  StripePublishableKey: 'pk_live_51TXQHJCvxesiL9O5hamhb9AKCsQqegbSkmF97Sq1qITVWbaeSKx3kmh336n4zuwdme2wxXDYNbYZkg1MmHdv2ReQ00rasni5I9',
  Url_Avisos_Privacidad: 'https://www.sorteoanahuac.mx/aviso-de-privacidad',
  Url_reglamento: 'https://www.sorteoanahuac.mx/reglamento-becario',
  Url_terminos: 'https://www.sorteoanahuac.mx/terminos-y-condiciones',
  correo_pasalavoz: 'voz.sorteo@anahuac.com',
  Urlsitio: 'https://www.sorteoanahuac.mx/',
  urlCompartirBoletos: 'https://sorteoanahuaccompra.sorteoanahuac.mx/boletos-colaborador/',

  // MIT en liga de colaborador (boletos-colaborador y venta-digital-externa). false = no sale
  // para boletos que pasaron por la liga; true = normal (lo que diga SGSA). Todo lo demas, normal.
  metodosPagoLigaColaborador: {
    mit: false,
  },

  ventaDigitalExterna: [
    133593, 133600, 133601, 133602, 133603, 133605, 133606,
    133607, 133608, 133609, 133614, 133615, 133616, 133617,133599,133596,103790,
    102475,
    133655, // MTMzNjU1
    133658, // MTMzNjU4
  ]
};